import React, { useContext, useEffect, useState } from 'react'
import { ChatbotStepActionData, CustomAPICallActionData } from '../../../../models/flowBuilderTypes'
import { Grid, Typography } from '@mui/material';
import styles from "../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss";
import globalStyle from "../../../../assets/styles/global.module.scss";
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { dataConnectorList } from '../../../../models/axiosModel';
import { fontColorForMethod } from '../../../../utils/constants';

function CustomAPICallNode(
    { id, data }: { id: string, data: ChatbotStepActionData<CustomAPICallActionData> }
) {

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload 
    const [dataConnectorDetails, setDataConnectorDetails] = useState<dataConnectorList | null>(null);

    useEffect(() => {
        let currentDataConnector = currentActiveStaticWorkflow?.additional_data?.data_connectors?.find((connector: dataConnectorList) => connector.chatbot_data_connector_id == data?.action_data?.data_connector?.chatbot_data_connector_id);
        if(currentDataConnector){
            setDataConnectorDetails(currentDataConnector);
        }
    }, [data.action_data])

    return (
        <>
            {data.action_data?.data_connector?.chatbot_data_connector_id ? 
                <div>
                    <Typography className={styles.dataSavedTextStyle}>{`Custom API `}</Typography>
                    <Typography className={styles.dataSavedValueStyle}>
                        <span style={{ color: fontColorForMethod(dataConnectorDetails?.function_method_name || "") }}>{dataConnectorDetails?.function_method_name ? dataConnectorDetails?.function_method_name : "System API"}</span>
                        {` - ${dataConnectorDetails?.data_connector_functions?.data_connector_function_name || ""}`}
                    </Typography>
                </div>
                :
                <>
                    <div>
                        <span className={styles.dataSavedTextStyle}>{`Custom API `}</span>
                        <span className={styles.dataSavedValueStyle}>
                            {"Please Configure Custom API*"}
                        </span>
                    </div>
                </>
            }
        </>
    )
}

export default CustomAPICallNode